.modal-body {
    font-weight: normal;
    color: var(--grey);
    font-size: var(--font-normal);
    line-height: 19px;
}
